module.exports = __webpack_public_path__ + "img/template2.71af33fd.jpg";